import styled from 'styled-components'


export const ListOfImages = styled.div``

export const ImageWrapper = styled.div`

  height: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .4s all;
  border-radius: 6px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);

  &:hover{
    cursor: pointer;

    box-shadow: 0px 10px 10px rgba(0,0,0,0.15)
  }
  img {
    width: 100%;
  }
`

export const Title = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.colors.thirdary};
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}


`
